var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("VueSkeletonLoader", {
    attrs: {
      type: _vm.defaults.type,
      width: "100%",
      height: "100%",
      animation: _vm.defaults.animation,
      color: _vm.defaults.color,
      "wave-color": _vm.defaults.waveColor,
    },
  })
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }